import { Briefcase, Award, GraduationCap, Scale, HeartPulse, Sparkles, Users, ShieldCheck } from 'lucide-react'

const ICON_MAP = { briefcase: Briefcase, award: Award, 'graduation-cap': GraduationCap, scale: Scale, 'heart-pulse': HeartPulse, sparkles: Sparkles }

const tiles = [
  ['briefcase', 'Emploi', "Offres & bourse d'emploi"],
  ['award', 'Concours', 'Calendrier & inscriptions'],
  ['graduation-cap', 'Formation', 'Catalogue CDG31'],
  ['scale', 'Statut', 'Fiches & circulaires'],
  ['heart-pulse', 'Sante', 'Medecine preventive'],
  ['sparkles', 'Assistant IA', 'Posez votre question', true],
]

export default function Cdg31Hero({ onOpenChat }) {
  return (
    <section className="cdg-hero-v3">
      <div className="cdg-hero-v3-deco" aria-hidden="true">
        <div className="cdg-hero-v3-blob cdg-hero-v3-blob-1" />
        <div className="cdg-hero-v3-blob cdg-hero-v3-blob-2" />
        <div className="cdg-hero-v3-grid" />
      </div>

      <div className="cdg-container cdg-hero-v3-inner">
        <div className="cdg-hero-v3-text">
          <span className="cdg-hero-v3-eyebrow">
            <span className="cdg-hero-v3-dot" />
            Haute-Garonne · Depuis 1987
          </span>
          <h1 className="cdg-hero-v3-title">
            L'expert RH des <em>450 collectivites</em><br />
            de Haute-Garonne.
          </h1>
          <p className="cdg-hero-v3-sub">
            Recrutement, formation, carriere, sante au travail, conseil juridique&nbsp;— le CDG31 accompagne les collectivites territoriales et leurs <strong>28&nbsp;000 agents</strong> au quotidien.
          </p>

          <div className="cdg-hero-v3-quickaccess">
            <div className="cdg-hero-v3-qa-label">Acces rapide</div>
            <div className="cdg-hero-v3-qa-grid">
              {tiles.map(([ic, t, s, isAI]) => {
                const Icon = ICON_MAP[ic]
                return (
                  <a
                    key={t}
                    className={'cdg-hero-v3-qa-tile' + (isAI ? ' cdg-hero-v3-qa-ai' : '')}
                    onClick={isAI ? onOpenChat : undefined}
                    style={isAI ? { cursor: 'pointer' } : undefined}
                  >
                    <div className="cdg-hero-v3-qa-ic"><Icon size={18} /></div>
                    <div className="cdg-hero-v3-qa-body">
                      <div className="cdg-hero-v3-qa-t">
                        {t}
                        {isAI && <span className="cdg-hero-v3-qa-new">Nouveau</span>}
                      </div>
                      <div className="cdg-hero-v3-qa-s">{s}</div>
                    </div>
                  </a>
                )
              })}
            </div>
          </div>
        </div>

        <div className="cdg-hero-v3-visual">
          <div className="cdg-hero-v3-photo">
            <img src="/assets/cdg31/visuels/actualites/batiment_CDG31.jpg" alt="Batiment du CDG31 a Labege" />
            <div className="cdg-hero-v3-photo-overlay" />
          </div>
          <div className="cdg-hero-v3-stat cdg-hero-v3-stat-tl">
            <div className="cdg-hero-v3-stat-ic"><Users size={22} /></div>
            <div>
              <div className="cdg-hero-v3-stat-n">28<span>k</span></div>
              <div className="cdg-hero-v3-stat-l">agents accompagnes</div>
            </div>
          </div>
          <div className="cdg-hero-v3-stat cdg-hero-v3-stat-br">
            <div className="cdg-hero-v3-stat-ic cdg-hero-v3-stat-ic-red"><Award size={22} /></div>
            <div>
              <div className="cdg-hero-v3-stat-n">120<span>+</span></div>
              <div className="cdg-hero-v3-stat-l">concours par an</div>
            </div>
          </div>
          <div className="cdg-hero-v3-badge">
            <ShieldCheck size={22} />
            <div>
              <strong>Qualiopi</strong>
              <span>Organisme certifie</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
